import React, { memo } from 'react';
import ClickableDiv from 'components/Common/ClickableDiv';
import { useHistory } from 'react-router-dom';
import Styles from './index.module.css';
import powerAILogo from '../../../assets/PowerAI-82x77-logo.png';
import pchomeLoginLogo from '../../../assets/PChomeLoginLogo.png';

function Logo() {
  const loginLogo = (window.location.hostname === 'pchome.powerai.com.tw' ? pchomeLoginLogo : powerAILogo);
  const history = useHistory();
  const onClick = () => history.push('/MyAds');
  return (
    <div className={Styles.logoContainer}>
      <ClickableDiv onClick={onClick} style={{ width: 'fit-content', height: 'fit-content' }}>
        <img
          className={Styles.img}
          src={loginLogo}
          alt="logo"
        />
      </ClickableDiv>
    </div>
  );
}

export default memo(Logo);
